module.exports = __webpack_public_path__ + "img/00036.bb368689.webp";